import React from 'react';
import {DotMenuSide} from 'components/Ui/Icon';
import Dropdown from './Dropdown';
import ApproachModal from './ApproachModal';

export default () => {
  const [approachModalVisible, setApproachModalVisible] = React.useState(false);

  return (
    <>
      <Dropdown
        options={[
          {
            label: 'アプローチ一括登録',
            onClick: () => setApproachModalVisible(true),
          },
        ]}
        className="cursor-pointer bg-transparent text-white border-none text-sm hover:bg-[#E9F4FF] rounded-full flex items-center justify-center h-8 w-8 disabled:bg-c-bg disabled:text-c-light">
        <DotMenuSide color={'var(--text-color-2)'} />
      </Dropdown>
      <ApproachModal
        visible={approachModalVisible}
        onClose={() => setApproachModalVisible(false)}
      />
    </>
  );
};
